export enum States {
  ITALY = 'Italy',  // 1 - Added by Francesco Torre
  VATICAN = 'Vatican', // 2 - Added by Francesco Torre
  SANMARINO = 'San Marino' // 3 - Added by Francesco Torre
}
